import { createDraftSafeSelector } from '@reduxjs/toolkit';

import type { RootState } from 'App/Store';

const getState = (state: RootState) => state.gates;

export const getGatesToken = createDraftSafeSelector(
  getState,
  (state) => state?.contextToken,
);

export const getGateMFAData = createDraftSafeSelector(
  getState,
  (state) => state?.mfa,
);

export const getIsVerifying = createDraftSafeSelector(
  getState,
  (state) => state?.isVerifying,
);

export const getSelectedDealerId = createDraftSafeSelector(
  getState,
  (state) => state?.selectedDealerId,
);

export const getGateConfig = createDraftSafeSelector(
  getState,
  (state) => state?.gateConfig,
);

export const getGateAuthToken = createDraftSafeSelector(
  getState,
  (state) => state?.token,
);